import AgreementInput from './AgreementInput';

export default AgreementInput;
